import { lazy, type ReactElement, useCallback, useEffect } from 'react'
import { exchangeToken } from '../services/api/auth'
import { redirectToUrl } from '../utils/location'
import { environmentVariables } from '../utils/environmentVariables'
import { useSearchParams } from 'react-router-dom'
import { clearSavedTokens, getRefreshToken, saveTokens } from '../services/authentication'

export const LazyCareAuthenticationRequest = lazy(() =>
  import('../pages/CareAuthenticationRequest/CareAuthenticationRequest').then((module) => ({
    default: module.CareAuthenticationRequest,
  })),
)

export const CareAuthenticationRequestRoute = (): ReactElement => {
  const [searchParams] = useSearchParams()

  const ensureUserIsAuthenticated = useCallback(() => {
    const refreshTokenCookie = getRefreshToken()
    if (refreshTokenCookie) {
      exchangeToken(refreshTokenCookie)
        .then((tokens) => saveTokens(tokens.access_token, tokens.refresh_token))
        .catch((_) => {
          clearSavedTokens()
          const url = new URL(`${environmentVariables('AUTH_API_URL')}/signin`)
          url.searchParams.append('origin', window.location.toString())
          redirectToUrl(url.toString())
        })
    } else {
      const url = new URL(`${environmentVariables('AUTH_API_URL')}/signin`)
      url.searchParams.append('origin', window.location.toString())
      redirectToUrl(url.toString())
    }
  }, [])

  useEffect(() => {
    if (searchParams.get('debug') === 'true') {
      return
    }
    ensureUserIsAuthenticated()
  }, [searchParams, ensureUserIsAuthenticated])

  return <LazyCareAuthenticationRequest />
}
